import axios from "axios";
const jsonConfig = require("../Config.json");

const getAllDomains = async () => {
  return axios.get(jsonConfig.apiUrl + "domains", {
    headers: {
      "x-functions-key": jsonConfig.key,
    },
  });
};

export default getAllDomains;
